<template>
  <div>
    <ol class="breadcrumb-steps nav nav-justified">
      <li v-for="(step, i) in steps" :key="i" class="breadcrumb-steps__step nav-item" :class="{ 'active': current_index === i }">
        <span class="breadcrumb-steps__step-inner nav-link">{{ step.title }}</span>
      </li>
    </ol>
    <vv-observer v-slot="{ invalid }">
      <div>
        <slot />
      </div>

      <div class="access-form__btns row">
        <div class="access-form__btn-col col">
          <button v-if="!isFirst" class="access-form__btn btn-rounded btn btn-block" :class="'btn-outline-' + $mainColor" @click.stop="previous" type="button">
            Précédent
          </button>
          <button v-else class="access-form__btn btn-rounded btn btn-block" :class="'btn-outline-' + $mainColor" @click.stop="cancel" type="button">
            Retour
          </button>
        </div>
        <div class="access-form__btn-col col">
          <button v-if="!isLast" class="access-form__btn btn-rounded btn btn-block ml-auto" :class="'btn-' + $mainColor" @click.stop="next" type="button" :disabled="invalid">
            Suivant
          </button>
          <s-button :loading="loading" v-if="isLast" @submit="submit" :disabled="invalid || uploadProgress" :css-class="'btn-block btn-' + $mainColor">
            Envoyer
          </s-button>
        </div>
      </div>
    </vv-observer>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Wizard',
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      steps: [],
      current_index: 0
    }
  },
  mounted () {
    this.steps = _.filter(this.$children[0].$children, child => child.$options.name === 'WizardStep')
    this.steps[this.current_index].active = true
  },
  computed: {
    ...mapState(['uploadProgress']),
    isFirst () {
      return this.current_index === 0
    },
    isLast () {
      return this.current_index === this.steps.length - 1
    }
  },
  methods: {
    move (index) {
      this.current_index = index
    },
    previous () {
      this.move(_.max([this.current_index - 1, 0]))
    },
    next () {
      this.move(_.min([this.current_index + 1, this.steps.length - 1]))
    },
    cancel () {
      this.$emit('cancel')
    },
    submit () {
      this.$emit('submit')
    }
  },
  watch: {
    current_index (newIndex, oldIndex) {
      this.steps[oldIndex].active = false
      this.steps[newIndex].active = true
    }
  }
}
</script>
